// extracted by css-extract-rspack-plugin
export default {"horizontalScroll":"ReferralProgram-module__horizontalScroll","desktop":"ReferralProgram-module__desktop","desktopReferContainer":"ReferralProgram-module__desktopReferContainer"};